/*
 * Copyright (c) 2021. Datafood srl
 * Developed by Revo Digital - revodigital.it
 * ---
 * Author: leonardoviada
 * File: ComingSoonCallout.tsx
 * Project: mle-client
 * Committed last: 2021/11/4 @ 138
 * ---
 */

import { Callout, Divider, Intent } from '@blueprintjs/core';
import React                        from 'react';

interface ComingSoonCalloutProps {
  nextFeatures: string[];
}

export const ComingSoonCallout = (props: ComingSoonCalloutProps) => {

  return (
    <div className="hidden">
      <Callout
        title="Nel prossimo rilascio"
        icon="fast-forward"
        intent={ Intent.NONE }
      >
        <ul className="list-disc">
          {
            props.nextFeatures.map((nextFeature, index) =>
              <li key={ index.toString() }>{ nextFeature }</li>
            )
          }
        </ul>
      </Callout>
      <Divider className="my-4"/>
    </div>
  );
};
